// "Swetha KUMAR" → "Swetha Kumar": a SHOUTED word becomes capitalised; a
// mixed-case word ("McDonald", "Dr") is left alone. Used by WhoLabel.
export const tidyName = (name) => String(name || '')
    .split(/(\s+)/)
    .map((w) => (w.length > 1 && w === w.toUpperCase() && /[A-Z]/.test(w)
        ? w.charAt(0) + w.slice(1).toLowerCase()
        : w))
    .join('');

export default tidyName;
